import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface TimestampOverlayProps {
  enabled: boolean;
  onEnabledChange: (enabled: boolean) => void;
  position: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
  onPositionChange: (position: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right') => void;
  format: 'date' | 'time' | 'both';
  onFormatChange: (format: 'date' | 'time' | 'both') => void;
}

export const TimestampOverlay = ({
  enabled,
  onEnabledChange,
  position,
  onPositionChange,
  format,
  onFormatChange,
}: TimestampOverlayProps) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <Label className="text-sm font-medium">Timestamp</Label>
        <Switch checked={enabled} onCheckedChange={onEnabledChange} />
      </div>

      {enabled && (
        <>
          <div className="space-y-2">
            <Label className="text-xs">Position</Label>
            <Select value={position} onValueChange={onPositionChange}>
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="top-left">Top Left</SelectItem>
                <SelectItem value="top-right">Top Right</SelectItem>
                <SelectItem value="bottom-left">Bottom Left</SelectItem>
                <SelectItem value="bottom-right">Bottom Right</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label className="text-xs">Format</Label>
            <Select value={format} onValueChange={onFormatChange}>
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="date">Date Only</SelectItem>
                <SelectItem value="time">Time Only</SelectItem>
                <SelectItem value="both">Date & Time</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </>
      )}
    </div>
  );
};
